import React, { useState, useRef, useEffect } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import fetch from 'isomorphic-unfetch';
// import { Button, TextInput, Text, RTNLink } from '@rtn-web/rtn-dsm-components/';
import { Button, TextInput, Text, RTNLink } from '@rtn-web/evergreen/';
import qs from 'qs';
import { connect } from 'react-redux';
import Dimmer from '../../components/Dimmer';
import Page from '../../layouts/main';

function ForgotPassword({
  highered,
  redirect,
  title,
}) {
  const [urlParams, setUrlParams] = useState('');
  const [email, setEmail] = useState(null);
  const [emailLower, setEmailLower] = useState(null);
  const [dimmed, setDimmed] = useState(false);
  const [messages, setMessages] = useState({
    error: null,
    success: null,
    help: null,
  });

  useEffect(() => {
    const uriParts = window.location.href.split('?');
    const params = qs.parse(uriParts[1]);
    let urlParams = '';
    urlParams += params.redirect ? `redirect=${redirect}` : '';
    urlParams += highered && highered.slug ? `&highered=${highered.slug}` : '';
    setUrlParams(urlParams);

    if (params && params.email && params.email.length > 0) {
      setEmail(params.email);
      setEmailLower(params.email.toLowerCase());
    }
    return () => {};
  }, []);

  const handleKeyPress = (e) => {
    if (e.keyCode == 13) {
      submitForm(e);
    }
  };

  const submitForm = (e) => {
    e.preventDefault();
    const url = `/api/getProviderRedirect/${emailLower}`;
    const send = async (userEmail) => await fetch(`/api/forgotpassword/${userEmail || emailLower}`);
    const validate = async () => await fetch(url);
    if (!emailLower || !emailLower.length > 0) {
      setMessages({
        success: null,
        help: null,
        error: 'Username or email is required',
      });
    } else {
      setDimmed(true);
      validate().then((data) => data.json()).then((res) => {
        const { type, success } = res;
        console.log('type', res);

        if (!success) {
          setMessages({ success: null, help: null, error: 'Invalid username or email' });
          setDimmed(false);
          return;
        }
        if (type == 'unknown' || type == 'local') {
          send(emailLower).then((ret) => ret.json()).then((sentRet) => {
            if (sentRet.sent) {
              setMessages({
                error: null,
                success: 'A link to reset your password has been sent to your inbox',
                help: "Haven't received an email? (Make sure to check your spam!)",
              });
            } else {
              setMessages({ success: null, help: null, error: 'There was an error in sending your email' });
            }
          });
        } else {
          setMessages({
            success: null,
            help: null,
            error: 'There was an error in sending your email, your account might be associated with social login',
          });
        }
        setDimmed(false);
      }).catch((err) => {
        console.log('err', err);

        setMessages({ success: null, help: null, error: 'There was an error' });
        setDimmed(false);
      });
    }
  };

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={`${title}`} />
      </Head>
      <Page>
        {dimmed && <Dimmer />}
        <div className="grid-x align-right">
          <div className="large-6 small-6 text-right mgb-32">
            <Text
              tag="p"
              variant="para-default-small-right"
              text="Don't have an account?"
            />
            <span>
              <RTNLink
                sameWindow
                link={`/user/signup?${urlParams}`}
                text="Create an account"
              />
            </span>
          </div>
          <div className="large-12 small-12">
            <Text tag="h1" variant="h-3-default-left" text="Reset Your Password" />
            <Text tag="p" variant="para-default-medium-left" text="Can't remember your password? No worries!" />
            <br />
            <Text
              tag="p"
              variant="para-default-medium-left"
              text="Enter the email address or username you provided when you set up your account, and we'll send you a link to update your password."
            />
            <br />
          </div>

          <form
            id="frm-forgot-password"
            onSubmit={submitForm}
            onKeyPress={(e) => handleKeyPress(e)}
          >
            <div className="large-12 small-12">
              <TextInput
                fieldId="username"
                value={email}
                placeholderText=""
                labelText="Username or Email"
                handleChange={(email) => {
                  setEmail(email);
                  setEmailLower(email.toLowerCase());
                }}
                type="text"
                isRequired
                errorText={messages.error}
                successText={messages.success}
                helpText={messages.help}
                submitForm={submitForm}
              />
            </div>
            <br />
            <div style={{
              display: 'flex',
              alignItems: 'center',
            }}
            >
              <Button type="PrimaryButton" text="Submit" action={(e) => submitForm(e)} />
              <span className="inline mgl-24">
                <RTNLink
                  sameWindow
                  basicBtn
                  link={`/user/login?${urlParams}`}
                  text="Cancel"
                />
              </span>
            </div>
          </form>
        </div>
      </Page>
    </>
  );
}

ForgotPassword.getInitialProps = async ({
  req, res, match, history, location, ...ctx
}) => { return { title: 'Forgot Password' }; };

function mapStateToProps({ main }) {
  return {
    redirect: main.redirect,
    highered: main.highered,
  };
}
ForgotPassword.propTypes = {
  title: PropTypes.string,
};

ForgotPassword.defaultProps = {
  title: 'Forgot Password',
};

export default connect(
  mapStateToProps,
)(ForgotPassword);
